<template>
  <section v-if="hasProducts" class="section">
    <div class="container-lg">
      <div class="section__header">
        <div class="row align-items-center">
          <div class="col-sm-8">
            <h2 class="section__title">{{ slider.title }}</h2>
            <div class="section__text">{{ slider.sub_title }}</div>
          </div>
          <div class="col-sm-4">
            <div class="text-right text-left-sm">
              <a :href="slider.link" :title="in18['page_see_all']" class="link link--blue fw-500">
                {{ in18['page_see_all'] }} »
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!-- /.container-lg -->
    <div :id="slider.type" :data-slider="slider.type" class="products-slider">
      <div v-for="product in slider.products" class="slider-item">
        <product-item :product="product"/>
      </div>
    </div><!-- /.products-slider -->
  </section>
</template>

<script>

/**
 * AutoSlider.
 *
 * @component
 * @name AutoSlider
 * @props {string} type - The type of slider.
 * @props {object} in18 - Internationalization data.
 */
export default {
  name:     "AutoSlider",
  props:    [
    'in18',
    'slider',
  ],
  computed: {
    /**
     * Check if there are products in the slider.
     *
     * @member {boolean}
     * @property {boolean} hasProducts - True if there are products, otherwise false.
     */
    hasProducts() {
      return (
          this.slider &&
          this.slider.is_active &&
          this.slider.products &&
          this.slider.products.length > 0
      );
    },
  },
  mounted() {
    this.activateSlick();
  },
  methods: {

    /**
     * Activate the Slick slider.
     *
     * @method
     */
    activateSlick() {

      $("[data-slider='" + this.slider.type + "']").slick({
        autoplay:       true,
        autoplaySpeed:  2000,
        infinite:       true,
        slidesToShow:   6,
        slidesToScroll: 1,
        arrows:         true,
        dots:           false,
        speed:          600,
        variableWidth:  true,
        lazyLoad:       'ondemand',
        responsive:     [
          {
            breakpoint: 1500,
            settings:   {
              slidesToShow: 4
            },
          },
          {
            breakpoint: 880,
            settings:   {
              slidesToShow: 3
            },
          },
          {
            breakpoint: 750,
            settings:   {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 380,
            settings:   {
              slidesToShow: 1
            },
          }
        ]
      });
    }
  },
};
</script>
